module.exports = __webpack_public_path__ + "static/media/step3.4b0a840d.png";